import { render, staticRenderFns } from "./companyprofile.vue?vue&type=template&id=823db38e&scoped=true&"
import script from "./companyprofile.vue?vue&type=script&lang=js&"
export * from "./companyprofile.vue?vue&type=script&lang=js&"
import style0 from "./companyprofile.vue?vue&type=style&index=0&id=823db38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823db38e",
  null
  
)

export default component.exports